import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMonetaryAmount } from '#src/hooks/useMonetaryAmount.ts';

import type {
  UpdateJonumPlaytimeLimitMutation,
  UpdateJonumPlaytimeLimitMutationVariables,
  UpdateJonumSpendingLimitMutation,
  UpdateJonumSpendingLimitMutationVariables,
} from './__generated__/mutations.graphql.ts';

export const UPDATE_JONUM_PLAYTIME_LIMIT = gql`
  mutation UpdateJonumPlaytimeLimitMutation(
    $input: setJonumPlaytimeLimitInput!
  ) {
    setJonumPlaytimeLimit(input: $input) {
      pendingEffectiveAt
      verification {
        id
        playtime {
          limitMinutes
          periodResetsAt
          usedMinutes
          pendingLimitChange {
            limitMinutes
            effectiveAt
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateJonumPlaytimeLimitMutation,
  UpdateJonumPlaytimeLimitMutationVariables
>;

export const UPDATE_JONUM_SPENDING_LIMIT = gql`
  mutation UpdateJonumSpendingLimitMutation(
    $input: setJonumSpendingLimitInput!
  ) {
    setJonumSpendingLimit(input: $input) {
      pendingEffectiveAt
      verification {
        id
        spending {
          limit {
            ...useMonetaryAmount_monetaryAmount
          }
          periodResetsAt
          used {
            ...useMonetaryAmount_monetaryAmount
          }
          pendingLimitChange {
            limit {
              ...useMonetaryAmount_monetaryAmount
            }
            effectiveAt
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${useMonetaryAmount.fragments.monetaryAmount}
` as TypedDocumentNode<
  UpdateJonumSpendingLimitMutation,
  UpdateJonumSpendingLimitMutationVariables
>;
